import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseFieldComponent } from '../base-field.component';

/**
 * Campo de tipo "heading" — solo texto, sin form control activo.
 * El contenido y el estilo se leen de field.customProps:
 *   text      → string (texto a mostrar)
 *   tag       → 'h1' | 'h2' | 'h3' | 'h4'  (default 'h2')
 *   align     → 'left' | 'center' | 'right' | 'justify' (default 'left')
 *   bold      → boolean (default true)
 *   italic    → boolean (default false)
 *   color     → string hex (default '#111827')
 *   fontSize  → number px (default 20)
 */
@Component({
  selector: 'app-heading-field',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="af-content-block af-content-block--heading" [ngStyle]="wrapperStyles">
      <span [ngStyle]="textStyles">{{ displayText }}</span>
    </div>
  `,
  styles: [`
    .af-content-block {
      width: 100%;
      padding: 2px 0;
      box-sizing: border-box;
    }
    .af-content-block span {
      display: block;
      line-height: 1.3;
      word-break: break-word;
    }
  `]
})
export class HeadingFieldComponent extends BaseFieldComponent {

  get p(): Record<string, unknown> {
    return (this.field.customProps as Record<string, unknown>) ?? {};
  }

  get displayText(): string {
    return String(this.p['text'] ?? this.field.label ?? 'Título');
  }

  get wrapperStyles(): Record<string, string> {
    return { textAlign: String(this.p['align'] ?? 'left') };
  }

  get textStyles(): Record<string, string> {
    return {
      fontSize:   `${this.p['fontSize'] ?? 20}px`,
      fontWeight: this.p['bold'] !== false ? '700' : '400',
      fontStyle:  this.p['italic'] ? 'italic' : 'normal',
      fontFamily: 'var(--af-heading-font-family, inherit)',
      color:      String(this.p['color'] ?? '#111827'),
      display:    'inline',
    };
  }
}
